import MessagingSectionLayout from './messagingSectionLayout.container';

export default MessagingSectionLayout;
